import { render, staticRenderFns } from "./PainelProjetosUap.vue?vue&type=template&id=01cc32d4"
import script from "./PainelProjetosUap.vue?vue&type=script&lang=js"
export * from "./PainelProjetosUap.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosUap.vue?vue&type=style&index=0&id=01cc32d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports